import React from 'react';
import style from './style.scss';

const ImportantList = () => {
    return (
        <div className="bank-account-not-have-card-list">
            <span className="bank-account-not-have-card-list-title">Importante</span>
            
            <ul className="not-have-card-list-item-wrap">
                <li className="bank-account-not-have-card-list-item">
                    <div className="bank-account-not-have-card-list-item-cont">
                        <i className="not-have-card-list-item-point">•</i>
                        <span className="not-have-card-list-item-text">Registra una cuenta vista/RUT o cuenta corriente (puedes autorizar la de otra persona). <strong>No se aceptan cuentas bipersonales, ni tarjetas virtuales</strong> (MACH, Tenpo, Chek, etc.).</span>
                    </div>

                </li>
                <li className="bank-account-not-have-card-list-item">
                    <div className="bank-account-not-have-card-list-item-cont">
                        <i className="not-have-card-list-item-point">•</i>
                        <span className="not-have-card-list-item-text">Una vez que tus datos bancarios estén registrados, los reembolsos se realizan en máximo de 5 días hábiles.</span>
                    </div>
                </li>
                <li className="bank-account-not-have-card-list-item">
                    <div className="bank-account-not-have-card-list-item-cont">
                        <i className="not-have-card-list-item-point">•</i>
                        <span className="not-have-card-list-item-text">Nuestra plataforma de pago no permite realizar transferencias a cuentas Coopeuch, Banco Ripley o Banco Internacional.</span>
                    </div>
                </li>
            </ul>
        </div>
    )
} 

export default ImportantList;